import { use } from "react";
import { TranslationsContext } from "./TranslationsContext";

export function useTranslations() {
  return use(TranslationsContext);
}
